export enum ProfileCategory {
  UNDEFINED = 'UNDEFINED',
  SPORT = 'SPORT',
  BLOGGER = 'BLOGGER',
  PERSONAL = 'PERSONAL',
  ANIMAL = 'ANIMAL',
  COMPANY = 'COMPANY',
}
